import { useEffect } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { setUnauthorizedHandler } from './api/client';
import { RequestLinkPage } from './pages/RequestLinkPage';
import { VerifyPage } from './pages/VerifyPage';
import { DashboardPage } from './pages/DashboardPage';
import { EditorPage } from './pages/EditorPage';

/**
 * App root. Wires the US6 reactive 401 handling onto the US2 interceptor
 * surface: any 401 from a PROTECTED endpoint navigates to `/` with a
 * session-expired flag. Auth endpoints are excluded inside the client, so an
 * invalid-link 401 cannot loop back here (AC6.2).
 */
export function App() {
  const navigate = useNavigate();

  useEffect(() => {
    setUnauthorizedHandler(() => {
      // Only redirect if the user is actually on a protected route right now.
      // Stale 401 promises from DashboardPage can resolve after the user has
      // navigated back to '/' — without this guard they'd trigger a spurious
      // "session expired" redirect on the sign-in page itself.
      const onProtectedRoute = window.location.pathname.startsWith('/ideas');
      if (!onProtectedRoute) return;

      const hadSession = localStorage.getItem('portal_had_session') === 'true';
      navigate(hadSession ? '/?expired=1' : '/', { replace: true });
    });
    return () => setUnauthorizedHandler(null);
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<RequestLinkPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/ideas" element={<DashboardPage />} />
      <Route path="/ideas/new" element={<EditorPage />} />
      <Route path="/ideas/:id/edit" element={<EditorPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
